// Each area of the app has its own JSON file per language.
// Keys are nested by area, e.g. t("dashboard.cards.allSms").
const namespaces = [
  "common",
  "nav",
  "apiErrors",
  "auth",
  "errorPages",
  "oauth",
  "dashboard",
  "smsLogs",
  "table",
  "integration",
  "hubspotIntegration",
  "tenantSettings",
  "howToUse",
  "systemTools",
  "users",
  "account",
  "team",
  "tenants",
  "usage",
];

const load = (lng) =>
  namespaces.reduce((acc, ns) => {
    acc[ns] = require(`./${lng}/${ns}.json`);
    return acc;
  }, {});

const resources = {
  "zh-TW": { translation: load("zh-TW") },
  en: { translation: load("en") },
};

export default resources;
